import React from 'react';

const CarouselStyles = (props, ref) => {
  return (
    <style jsx>
      {`
        .carousel .slider-wrapper {
          width: 100%;
          height: auto;
          padding: 8px 20px;
        }

        .carousel .control-next.control-arrow:before {
          border-left: 20px solid ${props.buttonTextColor};
        }
        .carousel .control-prev.control-arrow:before {
          border-right: 20px solid ${props.buttonTextColor};
        }

        .carousel.carousel-slider .control-arrow {
          top: 5px;
        }

        .carousel.carousel-slider {
          border: 2px solid ${props.buttonTextColor};
        }

        #input-with-icon-textfield {
          height: 45px;
        }

        #search_drop_down {
          height: 45px;
          padding-right: 10px;
          padding-left: 8px;
        }

        h1 {
          line-height: initial !important;
        }
      `}
    </style>
  );
};

export default CarouselStyles;
